import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {useAppSelector} from '@hooks/app';
import {TRACK_EVENTS, trackEvent} from '@utils/track';

/** user_navigation не шлём */
const AUTH_PATHS = new Set([
    '/login',
    '/registration',
    '/recovery-password',
    '/reset-password',
]);

const normalizePathname = (pathname: string): string => {
    const trimmed = pathname.replace(/\/+$/, '');

    return trimmed === '' ? '/' : trimmed;
};

export const UserNavigationTracker = (): null => {
    const {pathname} = useLocation();
    const token = useAppSelector(state => state.app.token);
    const lastSentPathRef = useRef<string | null>(null);

    useEffect(() => {
        const path = normalizePathname(pathname);

        if (!token?.token) {
            lastSentPathRef.current = null;
            return;
        }

        if (AUTH_PATHS.has(path)) {
            return;
        }

        if (lastSentPathRef.current === path) {
            return;
        }

        lastSentPathRef.current = path;
        trackEvent({event: TRACK_EVENTS.userNavigation}, token);
    }, [pathname, token]);

    return null;
};
